import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import StickyHeader from '../__header/stickyHeader';
import Accordion from '../__shortcodes/accordions';
import Tabs from '../__page/tabs';
import lightboxGallery from '../__page/lightboxGallery';
import { lightboxVideo } from '../__page/lightboxGallery';
import bindScrollEvents from '../__utils/lockScroll';
import Video from '../__utils/video';
import IsMac from '../__utils/addClassOnMac';
import { SimpleSlider, LightboxSlider } from '../__utils/sliders';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import SliderImageText from '../__page/sliderImgText';
import SliderQuotes from '../__page/sliderQuotes';
import StoriesPosts from '../__page/storiesPosts';
import DropdownList from '../__page/dropdownList';
import loadPostsBlog from '../__page/loadMorePosts';
import { loadPostsCl } from '../__page/loadMorePosts';
import scrollToBlogPosts from '../__utils/smoothScrollOnLoad';
import { scrollToCPTArchive, scrollToCLArchive, scrollToSJArchive } from '../__utils/smoothScrollOnLoad';
import ShowItemOnScroll from '../__page/showItemOnScroll';
import embedGoogleMap from '../__utils/googleMap';
import scrollToNextSection from '../__utils/scrollToNextSection';
import scrollDownHero from '../__page/scrollDownHero';
import showHideContent from '../__utils/showHideContent';
import AddTransparency from '../__page/addtransparencytoheader';
import setCaptPosVideo from '../__utils/setCaptionPosition';
import { setCaptPosGallery } from '../__utils/setCaptionPosition';
import navSlider from '../__utils/navSlider';
import setSJIntroHeight from '../__page/setIntroHeight';
import { setRegionIntroHeight } from '../__page/setIntroHeight';
import SelectRandomItem from '../__utils/selectRandomItem';

const headerMobile = new MobileHeader();
const stickyHeader = new StickyHeader();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        MegaMenu.init();
        headerMobile.init();
        Accordion.init();
        Tabs.init();
        bindScrollEvents();
        Video();
        IsMac();
        SimpleSlider.init();
        LightboxSlider.init();
        lightboxGallery.init();
        lightboxVideo.init();
        smoothScroll();
        Tables.init();
        SliderImageText.init();
        SliderQuotes.init();
        StoriesPosts.init();
        DropdownList.init();
        loadPostsBlog.init();
        loadPostsCl.init();
        embedGoogleMap.init();
        scrollToNextSection.init();
        scrollDownHero.init();
        showHideContent.init();
        AddTransparency.init();
        navSlider.init();
        SelectRandomItem.init();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        headerMobile.setProperMenuHeight();
        scrollToBlogPosts.init();
        scrollToCLArchive.init();
        scrollToSJArchive.init();
        setCaptPosVideo.init();
        setCaptPosGallery.init();
        setSJIntroHeight.init();
        setRegionIntroHeight.init();
    },
    resized() {
        headerMobile.resized();
        Tables.toggleTablesShadow();
        Tables.responsiveTableWidth();
        lightboxGallery.refreshSlider();
        headerMobile.setProperMenuHeight();
        setCaptPosVideo.init();
        setCaptPosGallery.init();
        scrollDownHero.setScrollBtnPos();
        navSlider.setNavItemsHeight();
        setSJIntroHeight.init();
        setRegionIntroHeight.init();
    },
    scrolled() {
        stickyHeader.init();
        ShowItemOnScroll.init();
        scrollDownHero.setScrollBtnPos();
    },
    mouseUp(e) {
        headerMobile.hideOutsideClick(e);
    },
};
export default controller;
